import {
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';

import MedalShape from './medal-shape';
import { getWrapperClasses, getWrapperStyles } from './styles';

export default function Save({ attributes }) {
  const { shape, label } = attributes;

  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  const innerBlocksProps = useInnerBlocksProps.save({
    className: 'brandy-medal__content',
  });

  // Both sides render the same catalogue path; `--end` is flipped by the
  // stylesheet. Dropped entirely rather than left as empty boxes when the
  // shape is off, so the content is not held off-centre by two dead slots.
  const sideShape = (side) =>
    shape &&
    shape !== 'none' && (
      <span className={`brandy-medal__shape brandy-medal__shape--${side}`}>
        <MedalShape shape={shape} />
      </span>
    );

  return (
    <div {...blockProps}>
      <div className="brandy-medal__body">
        {sideShape('start')}
        <div {...innerBlocksProps} />
        {sideShape('end')}
      </div>
      {!RichText.isEmpty(label) && (
        <RichText.Content
          tagName="p"
          className="brandy-medal__label"
          value={label}
        />
      )}
    </div>
  );
}
